import { gql } from "@apollo/client"

export const getRejectLogBySubmission = gql`
query getRejectLogBySubmission($submission: ID!){
  RejectLogBySubmission(submission: $submission) {
    id
    createdAt
    modifiedAt
    comment
    rejectedOnStatus
    owner {
      id
      displayName
      uid
      email
      roles {
        role
        regions
      }
    }
  }
}`